import { CropperSelection } from 'cropperjs'

export const getTemplate = ({
  aspectRatio,
  resizable,
  height,
  width,
  x,
  y
}: Partial<
  Pick<
    CropperSelection,
    'x' | 'y' | 'width' | 'height' | 'aspectRatio' | 'resizable'
  >
>) => {
  // 是否允许用户自己自定义选择框（裁剪框）
  const selectable = !(width || height)
  const mergedResizable = resizable || selectable
  const mergedWidth = width ?? (height ?? 0) * (aspectRatio ?? 1)
  const mergedHeight = height ?? (width ?? 0) / (aspectRatio ?? 1)

  return `
    <cropper-canvas background>
      <cropper-image rotatable scalable skewable translatable></cropper-image>
    ${
      selectable
        ? '<cropper-handle action="select" plain></cropper-handle>'
        : `
      <cropper-handle action="move" plain></cropper-handle>
      <cropper-shade
          x=${x} 
          y=${y} 
          width=${mergedWidth} 
          height=${mergedHeight}
          theme-color='rgba(0, 0, 0, 0.5)'>
      </cropper-shade>
      `
    }
    <cropper-selection
          id="cropperSelection"
          movable
          aspect-ratio=${aspectRatio}
          resizable
          x=${x}
          y=${y}
          width=${mergedWidth} 
          height=${mergedHeight}>
        <cropper-grid role="grid" covered></cropper-grid>
        <cropper-crosshair
                centered 
                theme-color="rgba(238, 238, 238, 0.5)">
        </cropper-crosshair>
        <cropper-handle 
                action="move" 
                theme-color="rgba(255, 255, 255, 0.35)">
        </cropper-handle>
      ${
        mergedResizable
          ? `
        <cropper-handle action="n-resize"></cropper-handle>
        <cropper-handle action="e-resize"></cropper-handle>
        <cropper-handle action="s-resize"></cropper-handle>
        <cropper-handle action="w-resize"></cropper-handle>
        <cropper-handle action="ne-resize"></cropper-handle>
        <cropper-handle action="nw-resize"></cropper-handle>
        <cropper-handle action="se-resize"></cropper-handle>
        <cropper-handle action="sw-resize"></cropper-handle>
        `
          : ''
      }
    </cropper-selection>
</cropper-canvas>
`
}
